module.exports = __webpack_public_path__ + "img/delete.b4e812eb.svg";